import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import PMCLogo from '../../../asset/image/moving-company-logo-01.png';
import emailImg from '../../../asset/image/email.png';
import telephoneImg from '../../../asset/image/telephone.png';
import pinImg from '../../../asset/image/placeholder-2.png';
import borderImg from '../../../asset/image/border.png';
import contactImg from '../../../asset/image/contacts.png';
import { Typography } from '@material-ui/core';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import { useTranslation } from 'react-i18next';

export default function Header() {
	const currentYear = new Date().getFullYear();
	const { t } = useTranslation();

	return (
		<>
			<Grid
				container
				style={{
					justifyContent: 'center',
					alignItems: 'center',
					textAlign: 'center',
					paddingTop: '1em',
					paddingBottom: '2em',
					backgroundColor: '#323b4d',
				}}
				direction='column'>
				<Grid
					item
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						padding: '10px',
					}}
					direction='column'>
					{/* <img
            src={PMCLogo}
            style={{ maxWidth: "200px", cursor: "pointer" }}
            onClick={() =>
              (window.location.href = "https://professionalmovingcompany.nl/")
            }
          /> */}
					<Typography
						variant='h2'
						style={{
							color: '#fff',
							fontSize: '36px',
							marginTop: '1em',
							fontFamily: 'Raleway, sans-serif',
						}}
						gutterBottom>
						{t('bookYourMoveOnlineToday')}
					</Typography>
					<img
						src={borderImg}
						style={{ maxWidth: '200px' }}
					/>
					{/* <img src={contactImg} /> */}
					<a
						href='mailto:info@professionalmovingcompany.nl'
						style={{ textDecoration: 'none' }}>
						<Typography
							variant='h2'
							style={{
								color: '#fff',
								fontSize: '18px',
								marginTop: '1em',
								fontFamily: 'Raleway, sans-serif',
								display: 'flex',
								gap: '10px',
								wordBreak: 'break-all',
								cursor: 'pointer',
							}}
							gutterBottom
							// onClick={() => {
							//   window.open("https://professionalmovingcompany.nl/", "_blank");
							// }}
						>
							<MailOutlineIcon /> info@professionalmovingcompany.nl
						</Typography>
					</a>
					<a
						href='tel:+31 618225041'
						style={{ textDecoration: 'none' }}>
						<Typography
							variant='h2'
							style={{
								color: '#fff',
								fontSize: '18px',
								marginTop: '1em',
								fontFamily: 'Raleway, sans-serif',
								display: 'flex',
								gap: '10px',
								cursor: 'pointer',
							}}
							gutterBottom
							// onClick={() => {
							//   window.open("https://professionalmovingcompany.nl/", "_blank");
							// }}
						>
							<PhoneIcon />
							+31 618225041
						</Typography>
					</a>
				</Grid>
				<Grid
					item
					style={{
						width: '100%',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					direction='column'>
					<hr
						style={{
							width: '90%',
							display: 'block',
							height: '1px',
							border: '0',
							borderTop: '1px solid #46525e',
							margin: '1em 0',
							padding: 0,
						}}
					/>
					<Typography
						variant='p'
						style={{
							color: '#fff',
							fontSize: '14px',
							marginTop: '1em',
							fontFamily: 'Raleway, sans-serif',
						}}
						gutterBottom>
						Copyright © {currentYear} Professional Moving Company – All Rights Reserved
					</Typography>
				</Grid>
			</Grid>
		</>
	);
}
